import { Participant } from "../types/participant";

import { ParticipantItem } from "./participant-item";

type ParticipantsListProps = {
  participants: Participant[];
  notFoundMessage?: string;
};

export function ParticipantsList({
  participants,
  notFoundMessage,
}: ParticipantsListProps) {
  if (participants.length === 0) {
    return (
      <p className="rounded-md border border-input bg-card px-4 py-3 text-sm text-foreground">
        {notFoundMessage ?? "No participants found"}
      </p>
    );
  }

  return (
    <ul className="divide-y divide-input rounded-md border border-input bg-card">
      {participants.map((participant) => (
        <ParticipantItem
          key={participant.participantId}
          participant={participant}
        />
      ))}
    </ul>
  );
}
